<template>
	<div id="topuPage">
		<wc-topu></wc-topu>
	</div>
</template>
<script>
	export default{
		name:'Topu',
		data(){
			return{
				
			}
		},
		methods:{
			calculateHeight(){
				//首先获取页面的高度
				var bodyHei = document.documentElement.clientHeight;
				//tabbar的高度为
				var tabbarHei = 51;
				//设置内容区的高度
				var minePage = document.getElementById("topuPage");
				minePage.style.height = bodyHei-tabbarHei+"px";
			}
		},
		mounted() {
			this.calculateHeight();
		}
	}
</script>
<style scoped="scoped">
	#topuPage{
		overflow-y: auto;
	}
</style>


// WEBPACK FOOTER //
// src/views/topu/Topu.vue